import Navbar from '../../../components/feature/Navbar';
import Footer from '../../../components/feature/Footer';
import SEOHead from '../../../components/base/SEOHead';
import RelatedResources from '../../../components/feature/RelatedResources';
import { Link } from 'react-router-dom';
import UTEPHero from './components/UTEPHero';
import UTEPLocation from './components/UTEPLocation';
import UTEPEconomicImpact from './components/UTEPEconomicImpact';
import UTEPRealEstate from './components/UTEPRealEstate';
import UTEPBusinessPrograms from './components/UTEPBusinessPrograms';
import UTEPCertificatesAndCTA from './components/UTEPCertificatesAndCTA';

export default function UTEPPage() {
  const relatedResources = [
    {
      title: 'Business Plan Template',
      description: 'Use your UTEP education to create a comprehensive business plan for your startup.',
      path: '/resources/business-plan-template',
      icon: 'ri-file-text-line'
    },
    {
      title: 'Small Business Loans',
      description: 'Explore financing options to fund your business after completing your UTEP education.',
      path: '/resources/small-business-loans',
      icon: 'ri-money-dollar-circle-line'
    },
    {
      title: 'Networking Opportunities',
      description: 'Connect with El Paso\'s business community and UTEP alumni network.',
      path: '/networking',
      icon: 'ri-team-line'
    }
  ];

  return (
    <>
      <SEOHead
        title="UTEP Business Programs & Real Estate Guide El Paso"
        description="Comprehensive guide to UTEP business programs, real estate opportunities, and economic impact in El Paso. Learn about MBA programs, business degrees, certificates, and investment opportunities near UTEP campus."
        canonical="/guides/utep"
        keywords="UTEP business programs, UTEP MBA, El Paso real estate, UTEP economic impact, business degrees El Paso, UTEP real estate concentration"
        ogImage="https://public.readdy.ai/ai/img_res/54313b6aeb15a50678bfaeafe0dd981c.jpg"
      />
      <div className="min-h-screen bg-white">
        <Navbar />
        
        <main id="main-content">
          {/* Breadcrumb */}
          <div className="max-w-7xl mx-auto px-6 pt-32">
            <nav aria-label="Breadcrumb" className="mb-8">
              <Link 
                to="/guides" 
                className="text-[#D2691E] hover:underline text-sm font-medium"
                aria-label="Return to Guides page"
              >
                ← Back to Guides
              </Link>
            </nav>

            {/* Breadcrumb Structured Data */}
            <script type="application/ld+json">
              {JSON.stringify({
                "@context": "https://schema.org",
                "@type": "BreadcrumbList",
                "itemListElement": [
                  {
                    "@type": "ListItem",
                    "position": 1,
                    "name": "Home",
                    "item": "https://elpasotexasbusiness.com/"
                  },
                  {
                    "@type": "ListItem",
                    "position": 2,
                    "name": "Guides",
                    "item": "https://elpasotexasbusiness.com/guides"
                  },
                  {
                    "@type": "ListItem",
                    "position": 3,
                    "name": "UTEP Business Guide",
                    "item": "https://elpasotexasbusiness.com/guides/utep"
                  }
                ]
              })}
            </script>
          </div>

          <UTEPHero />
          <UTEPLocation />
          <UTEPEconomicImpact />
          <UTEPRealEstate />
          <UTEPBusinessPrograms />
          <UTEPCertificatesAndCTA />

          <RelatedResources resources={relatedResources} />
        </main>

        <Footer />
      </div>
    </>
  );
}